<template>
  <div class="CustomLandingCover" v-if="landing">
    <section class="banner">
      <div v-if="landing.cover_video">
        <div class="bb-hidden-sm-min">
          <div class="contenedor">
            <video
              class="coverVideo full-width"
              :src="landing.cover_video"
              autoplay
              loop
              muted
            ></video>
            <div class="textOverVideo bb-column bb-text-white absolute">
              <div class="title bb-letter-spacing-2 sofia-font">
                {{ landing.title }}
              </div>
              <div class="subtitle">{{ landing.subtitle }}</div>
            </div>
          </div>
        </div>

        <div class="bannerContainer bb-show-sm-min">
          <div
            class="textOverlayMobile container bb-letter-spacing-2 bb-text-white"
          >
            <div class="title sofia-font">{{ landing.title }}</div>
            <div class="subtitle">{{ landing.subtitle }}</div>
          </div>
        </div>
      </div>

      <div v-else class="bannerContainer full-width">
        <div v-if="showBannerImage" class="bannerImage">
          <img
            class="bannerImage__img bannerImage__img--small"
            :src="
              landing.cover_image_small ??
              landing.cover_image_medium ??
              landing.cover_image_large
            "
            alt="Small cover image"
          />
          <img
            class="bannerImage__img bannerImage__img--medium"
            :src="
              landing.cover_image_medium ??
              landing.cover_image_large ??
              landing.cover_image_small
            "
            alt="Medium cover image"
          />
          <img
            class="bannerImage__img bannerImage__img--large"
            :src="
              landing.cover_image_large ??
              landing.cover_image_medium ??
              landing.cover_image_small
            "
            alt="Large cover image"
          />
        </div>
        <div class="content-overlay">
          <img
            v-if="landing.cover_logo"
            class="--image bb-mb-4"
            :src="landing.cover_logo"
          />
          <div class="--texts bb-column">
            <span
              class="--title sofia-font"
              :style="{ color: `${landing.color}` }"
              >{{ landing.title }}</span
            >
            <span
              class="--subtitle quicksand-font"
              :style="{ color: `${landing.color}` }"
              >{{ landing.subtitle }}</span
            >
          </div>
        </div>
      </div>
    </section>

    <section class="timeSection" v-if="landing.show_counter">
      <div class="timeContainer container">
        <div class="timeWrapperForMobile">
          <div class="timeWrapper bb-row bb-align-items-center">
            <span class="timeText bb-letter-spacing-2 sofia-font">
              <span>¡{{ $translate('Apurate') }}! Quedan:</span>
            </span>
            <span :style="{ color: `${landing.color}` }" class="timeBlocks">
              <span class="timeBlock bb-text-center">
                {{ getDays }}
                <span class="sofia-font">
                  &nbsp;{{ plural(getDays, 'día') }}
                </span>
              </span>
              <span class="timeBlock bb-text-center">
                {{ getHours }}
                <span class="sofia-font">
                  &nbsp;{{ plural(getHours, 'hora') }}
                </span>
              </span>
              <span class="timeBlock bb-text-center">
                {{ getMinutes }}
                <span class="sofia-font">
                  &nbsp;{{ plural(getMinutes, 'minuto') }}
                </span>
              </span>
            </span>
          </div>
        </div>
        <img
          class="creditCards"
          src="~assets/images/paymentmethod.png"
          alt="métodos de pago"
        />
      </div>
    </section>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import moment from 'common/deps/moment';

  @Component({
    props: {
      landing: {
        type: Object,
        required: true,
      },
    },
  })
  export default class CustomLandingCoverComponent extends Vue {
    timeLeft = null;
    showBannerImage = false;

    beforeMount() {
      if (this.landing.show_counter) {
        this.setTimer(this.landing.end_date);
      }

      this.showBannerImage =
        !!this.landing.cover_image_small ||
        !!this.landing.cover_image_medium ||
        !!this.landing.cover_image_large;

      console.log(this.showBannerImage);
    }

    /* Set the timeLeft for the countdown calculing the difference
     * between endDate and the current date every minute
     */
    setTimer(endDate) {
      this.timeLeft = moment.duration(moment(endDate).diff(moment()));
      setTimeout(() => {
        this.setTimer(endDate);
      }, 60000);
    }

    get getDays() {
      return this.landing ? this.timeLeft.days() : '0';
    }

    get getHours() {
      return this.landing ? this.timeLeft.hours() : '0';
    }

    get getMinutes() {
      return this.landing ? this.timeLeft.minutes() : '0';
    }
  }
</script>

<style lang="scss" scoped>
  @import '~assets/styles/index.scss';

  .CustomLandingCover {
    position: relative;
  }

  .bannerContainer {
    display: block;
    background: center no-repeat;
    background-size: cover;

    @media (min-width: 599px) {
      height: calc(100vh - 80px);
      max-height: 525px;
    }
  }

  .bannerImage {
    position: absolute;
    height: 100%;
    width: 100%;
    margin-inline: auto;

    @media (max-width: 600px) {
      height: auto;
      display: contents;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;

      @media (max-width: 600px) {
        height: auto;
      }
    }

    &__img--small {
      display: none;
      @media screen and (max-width: 600px) {
        display: block;
      }
    }
    &__img--medium {
      display: none;
      @media screen and (min-width: 601px) and (max-width: 900px) {
        display: block;
      }
    }
    &__img--large {
      display: none;
      @media screen and (min-width: 901px) {
        display: block;
      }
    }
  }

  .coverVideo {
    display: block;
    height: 400px;
    object-fit: cover;
  }

  .textOverVideo {
    top: 30%;
    left: 14%;

    .title {
      font-size: 80px;
      line-height: 40px;

      @media (max-width: $screen-md-min) {
        line-height: 60px;
      }

      @media (max-width: $screen-sm-min) {
        font-size: 70px;
      }

      @media (max-width: $screen-xs-min) {
        font-size: 60px;
      }
    }

    .subtitle {
      font-size: 25px;
      letter-spacing: -1.2px;
      margin-top: $SMALL;

      @media (max-width: $screen-sm-min) {
        font-size: 40px;
      }

      @media (max-width: $screen-xs-min) {
        font-size: 30px;
      }
    }
  }

  .content-overlay {
    position: relative;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-content: center;
    max-width: 1200px;
    margin-inline: auto;
    padding: 24px;

    @media (max-width: 600px) {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      height: auto;
    }

    .--image {
      width: Max(110px, 16vw);
      margin-right: 25px;
    }

    .--texts {
      .--title {
        font-size: 60px;
        letter-spacing: -4px;
        line-height: 1;

        @media (max-width: $screen-sm) {
          font-size: 30px;
          letter-spacing: -1.7px;
        }
      }

      .--subtitle {
        font-size: 25px;
        letter-spacing: -1.2px;
        margin-top: $SMALL;

        @media (max-width: $screen-sm) {
          font-size: 17px;
          letter-spacing: -1.1px;
          font-weight: 500;
        }
      }
    }
  }

  .textOverlayMobile {
    .title {
      font-size: 40px;
      letter-spacing: -1.7px;
      line-height: 1;
      max-width: 50%;
    }

    .subtitle {
      font-size: 17px;
      letter-spacing: -1.1px;
      font-weight: 500;
      margin-top: 15px;
    }
  }

  .timeSection {
    background-color: #f8f8f8;
    border: solid 1px #ebebeb;

    @media (max-width: $screen-sm-max) {
      background-color: transparent;
      border: none;
    }
  }

  .timeContainer {
    display: flex;
    align-items: center;

    @media (min-width: $screen-md-min) {
      min-height: 80px;
      padding: 0;
    }

    @media (max-width: $screen-sm-max) {
      flex-direction: column;
      width: 100%;
    }
  }

  .timeWrapper {
    @media (max-width: $screen-sm-max) {
      background-color: #f8f8f8;
      border: solid 1px #ebebeb;
      justify-content: center;
      margin-left: -$SMALL;
      margin-right: -$SMALL;
      padding: 25px $SMALL;
    }
  }

  .timeWrapperForMobile {
    @media (max-width: $screen-sm-max) {
      width: 100%;
    }
  }

  .timeText {
    font-size: $SMALL;
    color: $GRAY-PURPLEY;
    margin-right: 10px;

    @media (max-width: $screen-xs-max) {
      font-size: 18px;
    }
  }

  .timeBlocks {
    display: inline-flex;

    @media (max-width: $screen-sm-max) {
      margin-left: 8px;
    }
  }

  .timeBlock {
    font-size: 20px;
    letter-spacing: -1.7px;
    height: 40px;
    border: solid 1px $LIGHT-GRAY;
    background-color: $WHITE;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-left: 8px;
    padding: 10px 13px;
    border-radius: 4px;

    @media (max-width: $screen-sm-max) {
      font-size: 14px;
      letter-spacing: -1.1px;
      height: 32px;
      padding: 5px 6px;
    }
  }

  .creditCards {
    width: 468px;
    max-width: 100%;

    @media (min-width: $screen-md-min) {
      margin-left: auto;
    }

    @media (max-width: $screen-sm-max) {
      margin: $XXSMALL 0;
    }
  }
</style>
